import { ServiceContainerDto } from "../../../../../Api/Model/ServiceContainerDto.csharp";

export const serviceInitialState: ServiceContainerDto = {
  type: 1,
  containerId: "",
  isSpecialization: false,
  hideInDoctorBooking: false,
  specializationUrl: "",
  summaryName: "",
  bookingName: "",
  description: "",
  centerBookingOptions: [],
  noOnlineBookingInfo: "",
  newBookingQuickServiceName: "",
  pricingName: "",
  disableCenterAlert: false,
  enableVideoTelephoneOption: false,
  keywords: [],
  serviceUrl: "",
  disableDoctorSelection: false,
  showDoctorsJobTitle: false,
  priceDetailsLabel: "",
  disablePriceDetails: false,
  serviceGroupId: "",
  bookingGroupName: "",
  disableOptionalCampaignHighlight: false,
  disableDoctorPageListing: false,
  id: "",
  name: "",
  specializationId: "",
  availableForOnlineBooking: true,
  forcedOffline: false,
  isGroup: false,
  sortIndex: 0
};
